import { useState } from "react";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useCheckoutContext } from "context/checkout-context";
import {
  applyCoupon as applyCouponRequest,
  removeCoupon as removeCouponRequest
} from "./requests";
import { mountCustomError } from "utils/format";

export const useApplyCoupon = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { addNotification, removeNotification } = useShowSnackbar();
  const { device, getCheckoutData, setCouponApplied } = useCheckoutContext();

  const handleError = async (error) => {
    const notificationParams = {
      variant: "error",
      message: "",
      closeButton: false
    };
    const errorResponse = error.response.data.errors;
    if (!!errorResponse) {
      notificationParams.message = mountCustomError(errorResponse[0]);
    } else {
      notificationParams.message = "An error was occurred";
    }

    addNotification(notificationParams);
  };

  const applyCoupon = async ({ promoCode, paymentMethodUUID }) => {
    removeNotification(); // clear snackbar notifications
    try {
      setIsLoading(true);
      await applyCouponRequest({
        promoCode,
        device,
        payment_method_uuid: paymentMethodUUID
      });
      setCouponApplied(promoCode);
      addNotification({
        variant: "success",
        message: `Promo ${promoCode} applied successfully.`
      });
      await getCheckoutData();
    } catch (error) {
      handleError(error);
      setCouponApplied("");
    } finally {
      setIsLoading(false);
    }
  };

  const removeCoupon = async () => {
    try {
      setIsLoading(true);
      await removeCouponRequest();
      addNotification({
        variant: "success",
        message: "Promo code removed successfully."
      });
      await getCheckoutData();
    } catch (err) {
      addNotification({
        variant: "success",
        message: "Error removing promo code."
      });
    } finally {
      setIsLoading(false);
      setCouponApplied("");
    }
  };

  return {
    isLoading,
    applyCoupon,
    removeCoupon
  };
};
